jQuery(function ($) {

	console.log("main.js working"); 

    $('.back-to-top').click(function(){
        $('html, body').animate({scrollTop:0}, 'slow');
        return false;
    });

    //  MOBILE NAV CLICK 

	  var hamburger = document.querySelector(".hamburger");
	  var mobileNav = document.querySelector(".mobile-nav-buton");
	  var mobileMenu = document.querySelector(".mobile-menu");
	  var body = document.querySelector("#the_body");
	  
	  hamburger.addEventListener("click", function() {
	    hamburger.classList.toggle("is-active");
	    mobileMenu.classList.toggle("is-active");
	    body.classList.toggle('menu-open');
	  });

	// LOADER 

	$(document).ready(function() {
		$(".animsition").animsition({
			inClass: 'fade-in-up',
			outClass: 'fade-out-down',
			inDuration: 1000,
			outDuration: 600,
			linkElement: '.animsition-link',
			loading: true,
			loadingParentElement: 'body',
			loadingClass: 'animsition-loading',
			loadingInner: '',
			timeout: false,
			timeoutCountdown: 5000,
			onLoadEvent: true,
			browser: [ 'animation-duration', '-webkit-animation-duration'],
			overlay : false,
			overlayClass : 'animsition-overlay-slide',
			overlayParentElement : 'body',
			transition: function(url){ window.location.href = url; }
		});
	});

	setTimeout(function(){
		// RESIZE ORBIT
  		console.log("load event");
		$(window).trigger('resize');
	}, 1000);

	


});